module.exports = __webpack_public_path__ + "static/media/search-establishment.15b0c72f.svg";